import React, { useState, useEffect } from "react";
import { IonCol, IonRow } from "@ionic/react";
import "./doctor-list.scss";
import "../../../pages/CallSchedule/components/DayViewWrapper/DayViewWrapper.scss";
import DoctorCard from "./Components/DoctorCard/doctor-card";
import {
  doctorListResultInterface,
  doctorListInputData,
} from "../DoctorList/doctor-list.model";
import { doctorsListService } from "../DoctorList/doctor-list-service";
import { doctorListParams } from "../DoctorList/doctor-list.model";
import { DoctorDataModel } from "./Components/DoctorCard/doctor-card.model";
import { RolePermissionData } from "../../../models/rolePermission.model";
import { CONSTANTS } from "../../../constants";
import Loader from "../../Shared/Loader/Loader";
import _, { isEmpty } from "lodash";
import NoResults from "../NoResults/NoResultsComponent";
import { sBoardProviderService } from "../../../pages/StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider.service";
import { utilService } from "../../../services";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useNetwork } from "../../../helpers/NetworkContext";
import { useTranslation } from "react-i18next";

interface DoctorListPropsType {
  apiParams: doctorListParams;
  doctorListInputData: doctorListInputData;
  permissions: RolePermissionData;
  getSelectedCard: (data: Array<DoctorDataModel>) => void;
  getSelectedCardAndSchedule: (
    data: Array<DoctorDataModel>,
    scheduleName: any
  ) => void;
  getAllCards: (data: Array<DoctorDataModel>) => void;
  getAllCardsAndSchedule: (
    data: Array<DoctorDataModel>,
    scheduleName: any
  ) => void;
  getIsAllSelectedStatus: (data: boolean) => void;
  selectedAll?: boolean;
  doctorListDataFromParent?: Array<DoctorDataModel>;
  disableCardSelection?: boolean;
  searchText?: string;
  hideFeatureButtons?: boolean;
  isFullScreen?: boolean;
  isFileShareWebComponent?: boolean;
  homeGroupSmsScheduleName?: string;
  isFromCaseHistoryDetails?: any;
  patientID?: any;
  isFromOnCallSearch?: any;
  optionSelected?: string;
  isFromSpecialitySearch?: boolean;
  isAddedFav?: boolean;
  activeTab?: string;
  chatSelectedUser?: any;
  loader?: boolean;
  getSelected?:any;
  isManualAllSelect?:boolean;
  fetchSingleCard?:any;
}

const DoctorList: React.FC<DoctorListPropsType> = (props) => {
    const {t} = useTranslation("statusBoard");
  const {selectedNetwork} = useNetwork();
  const [doctorListData, setDoctorListData]: any = useState([]);
  const [filteredDoctorData, setFilteredDoctorData]: any = useState([]);
  const [searchedDoctorData, setSearchedDoctorData]: any = useState([]);
  const [selectedCards, setSelectedCards]: any = useState([]);
  const [isLoaderActive, setLoaderStatus] = useState<any>(true);
  const [columnSize, setColumnSize]: any = useState("12");
  const [isCoveredDoctorPresent, setIsCoveredDoctorPresent] = useState(true);
  const [scheduleName, setScheduleName]: any = useState("");
  const [istemplateAvailabilityPresent, setIstemplateAvailabilityPresent] =
    useState(false);
  const [templateAvailabilityList, setTemplateAvailabilityList] = useState<any>([]);
  const [doctorAvailableList, setDoctorAvailableList] = useState<any>([]);
  const [activeIndex, setActiveIndex] = useState<number>();

  let params = props.apiParams;
  let componentName = props.doctorListInputData.componentName;
  let isMultiSelectedEnabled = props.doctorListInputData.isMultiSelectEnabled;

  useEffect(() => {
    if (!_.isEmpty(doctorAvailableList)) {
      // to open all accordians by default
      const dayViewListIndexArray: any = [];
      doctorAvailableList.forEach((dayViewListItem: any, index: any) => {
        dayViewListIndexArray.push(index);
      });
      setActiveIndex(dayViewListIndexArray);
    }
  }, [doctorAvailableList]);

  useEffect(() => {
    if(props.selectedAll!==undefined){
      selectOrUnselectAllCards();
    }
  }, [props.selectedAll]);

  useEffect(() => {
    if (props.isAddedFav) {
      setDoctorListData(
        doctorListData?.map((data: any) => {
          return { ...data, isSelected: false };
        })
      );
    }
  }, [props.isAddedFav]);

  useEffect(() => {
    setScheduleName(props.homeGroupSmsScheduleName);
  }, [props.homeGroupSmsScheduleName]);

  useEffect(() => {
    filterDoctorListData(props.searchText);
  }, [props.searchText]);

  useEffect(() => {
    fetchDoctorDetails(componentName);
  }, [params, props.doctorListDataFromParent]);

  useEffect(() => {}, [searchedDoctorData]);

  useEffect(() => {
    props.getAllCards(doctorListData);
    checkCoveredDoctorPresent();
    // checkTempAvailabilyPresent();
    //Default card selection for FileShareWebComponent
    handleDefaultSelection();
  }, [doctorListData]);

  useEffect(() => {
    if (props.isFileShareWebComponent) {
      setColumnSize("12");
    } else {
      props.isFullScreen ? setColumnSize("4") : setColumnSize("12");
    }
  }, []);

  const handleDefaultSelection = () => {
    if (props.isFileShareWebComponent && !_.isEmpty(doctorListData)) {
      const selectedCardList: Array<DoctorDataModel> = [];
      selectedCardList.push(doctorListData[0]);
      doctorListData[0].isSelected = true;
      setSelectedCards(selectedCardList);
      //passing the selected cards to parent component
      props.getSelectedCard(selectedCardList);
      props.getAllCards(doctorListData);
      props.getIsAllSelectedStatus(isAllDoctorCardSelected(doctorListData));
    }
  };

  const filterDoctorListData = (newValue: any) => {
    const fullList = props?.doctorListDataFromParent?.map((data: any) => {
      if (
        selectedCards.find((selected: any) => selected?.guid === data?.guid)
      ) {
        return {
          ...data,
          isSelected: true,
        };
      } else {
        return data;
      }
    });

    if (newValue === "") {
      setDoctorListData(fullList);
    } else {
      if (
        props.doctorListDataFromParent &&
        props.doctorListDataFromParent.length
      ) {
        setLoaderStatus(true);
        if (newValue !== "" && newValue !== undefined) {
          var initialArray: any = [];
          initialArray = fullList?.filter(
            (provider: any) =>
              provider.firstName
                .toLowerCase()
                .includes(newValue.toLowerCase()) ||
              provider.lastName.toLowerCase().includes(newValue.toLowerCase())
          );
          if (!_.isEmpty(initialArray)) {
            setDoctorListData(initialArray);
          } else {
            setDoctorListData("");
          }

          // pass data to home group sms component
          props.getAllCardsAndSchedule(initialArray, scheduleName);
        } else {
          if (!_.isEmpty(props.doctorListDataFromParent)) {
            setDoctorListData(props.doctorListDataFromParent);
            // pass data to home group sms component
            props.getAllCardsAndSchedule(
              props.doctorListDataFromParent,
              scheduleName
            );
          } else {
            setDoctorListData("");
            // pass data to home group sms component
            props.getAllCardsAndSchedule([], scheduleName);
          }
        }
        setLoaderStatus(false);
      }
    }
  };

  const applyRule = (doctorListdata: any) => {
    if (componentName === CONSTANTS.COMPONENTS.UNASSIGNED_SHIFT) {
      const selectedCardList: Array<DoctorDataModel> = [];
      doctorListdata.map((listItem: DoctorDataModel) => {
        if (listItem.isPermanentlySelected) {
          listItem.isSelected = true;
          selectedCardList.push(listItem);
        }
      });
      setSelectedCards(selectedCardList);
      //passing the selected cards to parent component
      props.getSelectedCard(selectedCardList);
      props.getAllCards(doctorListData);
      props.getIsAllSelectedStatus(isAllDoctorCardSelected(selectedCardList));
    }
  };
  const setSelectedCardList = (card: DoctorDataModel) => {
    if(props.fetchSingleCard){
      props.fetchSingleCard(card)
    }
    if (!props.disableCardSelection) {
      if (isMultiSelectedEnabled) {
        setMultiSelectedCardList(card);
      } else {
        setNonMultiSelectedCardList(card);
      }
    }
  };

  const setMultiSelectedCardList = (card: DoctorDataModel) => {
    const selectedCardList: Array<DoctorDataModel> = selectedCards;
    const pushStatus = selectedCardList.find(
      (item: DoctorDataModel) => item.guid === card.guid
    );

    if (!card.isPermanentlySelected) {
      if (!pushStatus) {
        selectedCardList.push(card);
        props.getSelectedCard([...selectedCardList]);
        setSelectedCards([...selectedCardList]);
      } else {
        if (selectedCardList.length === 1) {
          // if final unselection
          selectedCardList[0].isSelected = false;
          selectedCardList.splice(0, 1);
        } else {
          _.remove(selectedCardList, { guid: card.guid });
        }
      }
    }

    setSelectedCards([...selectedCardList]);

    doctorListData.forEach((listItem: DoctorDataModel) => {
      if (selectedCardList.find((item) => item.guid === listItem.guid)) {
        listItem.isSelected = true;
      } else if (
        pushStatus &&
        listItem.guid === card.guid &&
        !listItem.isPermanentlySelected
      ) {
        listItem.isSelected = false;
      }
    });

    setDoctorListData([...doctorListData]);

    // passing data to parent component
    props.getSelectedCard([...selectedCardList]);

    if(props?.getSelected){
      props?.getSelected(card);
    }

    props.getAllCards([...doctorListData]);

    props.getIsAllSelectedStatus(isAllDoctorCardSelected(doctorListData));

    // passing data to homeGroupSms component
    props.getSelectedCardAndSchedule(selectedCardList, scheduleName);
  };

  const setNonMultiSelectedCardList = (card: any) => {
    const updatedDoctorListData = doctorListData.map(
      (item: DoctorDataModel) => {
        if (card.guid === item.guid) {
          item.isSelected = !item.isSelected;
          return item;
        } else {
          item.isSelected = false;
          return item;
        }
      }
    );

    let selectedDr: any;
    if (
      (props?.optionSelected === "speciality" ||
        props?.optionSelected === "group") &&
      props?.doctorListInputData?.componentName === "OnCallLookUp" 
    ) {
      if(props?.activeTab === "oncall"){
        setDoctorAvailableList([
          ...doctorAvailableList?.map((schedule: any) => {
            return {
              ...schedule,
              users: [
                ...schedule?.users?.map((doctor: any) => {
                  if (card.guid === doctor.guid) {
                    doctor.isSelected = !doctor.isSelected;
                    selectedDr = doctor;
                    return doctor;
                  } else {
                    doctor.isSelected = false;
                    return doctor;
                  }
                }),
              ],
            };
          }),
        ]);
      }else if(props?.activeTab==="notoncall" && card?.availableWhenNotOncall){
       
        setTemplateAvailabilityList([
          ...templateAvailabilityList?.map((doctor: any) => {
            if (card.guid === doctor.guid) {
              doctor.isSelected = !doctor.isSelected;
              selectedDr = doctor;
              return doctor;
            } else {
              doctor.isSelected = false;
              return doctor;
            }
          })
        ]);
      }

      setSelectedCards(
        selectedDr?.isSelected
          ? doctorsListService?.setDoctorListModel([selectedDr])
          : []
      );
      // Passing the selected cards to the parent component
      props.getSelectedCard(
        selectedDr?.isSelected
          ? doctorsListService?.setDoctorListModel([selectedDr])
          : []
      );
    } else {
      const selectedCardList = updatedDoctorListData.filter(
        (item: DoctorDataModel) => item.isSelected
      );
      setSelectedCards(selectedCardList);
      // Passing the selected cards to the parent component
      props.getSelectedCard(selectedCardList);
    }

    props.getAllCards(updatedDoctorListData);
    props.getIsAllSelectedStatus(
      isAllDoctorCardSelected(updatedDoctorListData)
    );
  };

  const isAllDoctorCardSelected = (doctorListData: Array<DoctorDataModel>) => {
    var isAllSelected: boolean;
    if (doctorListData.length > 0) {
      isAllSelected = doctorListData.every(
        (item: any) => item.isSelected == true
      );
    } else {
      isAllSelected = false;
    }
    return isAllSelected;
  };

  const checkCoveredDoctorPresent = () => {
    if (
      props.doctorListInputData.componentName ===
      CONSTANTS.COMPONENTS.ONCALL_LOOK_UP
    ) {
      if (doctorListData && params) {
        if (doctorListData.length > 1 && params.guid) {
          setIsCoveredDoctorPresent(true);
        } else {
          setIsCoveredDoctorPresent(false);
        }
      }
    } else {
      setIsCoveredDoctorPresent(false);
    }
  };

  const filterSearchedCoverageDoctor = (doctorListResult: any) => {
    var searchedDoctorData: any = [];
    searchedDoctorData = utilService.findObject(
      doctorListResult,
      "guid",
      params.guid
    );
    setSearchedDoctorData(searchedDoctorData);
    var initialDoctorArray = doctorListResult;

    if (doctorListResult && params) {
      if (doctorListResult.length > 1 && params.guid) {
        utilService.removeObject(initialDoctorArray, "guid", params.guid);
      }
    }
    setFilteredDoctorData(initialDoctorArray);
  };

  const selectOrUnselectAllCards = () => {
    var selectedCardList: Array<DoctorDataModel> = [];
    if (doctorListData) {
      doctorListData.map((item: DoctorDataModel) => {
        if (props.selectedAll) {
          item.isSelected = true;
          if (!item.isPermanentlySelected) {
            selectedCardList.push(item);
          }
        } else {
          item.isSelected = false;
          // selectedCardList = [];
        }
      });
    }
    setSelectedCards(selectedCardList);
    //pass selectedCardList to parent component
    props.getSelectedCard(selectedCardList);
    props.getAllCards(doctorListData);
    //passing data to homeGroupSms component
    props.getSelectedCardAndSchedule(selectedCardList, scheduleName);
  };

  const fetchDoctorDetails = (componentName: string) => {
    switch (componentName) {
      case CONSTANTS.COMPONENTS.REQUEST_COVERAGE:
        getRequestCoverageDoctorListDetails(params);
        break;

      case CONSTANTS.COMPONENTS.ONCALL_LOOK_UP:
        getOnCallLookUpDoctorListDetails(params);
        break;

      case CONSTANTS.COMPONENTS.SWAP_CALL:
        getSwapCallDoctorListDetails(params);
        break;

      case CONSTANTS.COMPONENTS.UNASSIGNED_SHIFT:
        getUnassignedUserList(params);
        break;

      case CONSTANTS.COMPONENTS.STATUS_BOARD:
        if (
          props.doctorListDataFromParent &&
          props.doctorListDataFromParent.length
        ) {
          if (!_.isEmpty(props.doctorListDataFromParent)) {
            setDoctorListData(_.cloneDeep(props.doctorListDataFromParent));
            sBoardProviderService.setDoctorListDataFromComponent(
              _.cloneDeep(props.doctorListDataFromParent)
            );
          } else {
            setDoctorListData("");
          }
        } else {
          getStatusBoardDoctorListDetails(params);
        }
        break;

      case CONSTANTS.COMPONENTS.GROUP_SMS:
        if (!_.isEmpty(props.doctorListDataFromParent)) {
          setDoctorListData(_.cloneDeep(props.doctorListDataFromParent));
        } else {
          setDoctorListData("");
        }
        setLoaderStatus(false);
        break;

      case CONSTANTS.COMPONENTS.FILE_SHARE:
        if (!_.isEmpty(props.doctorListDataFromParent)) {
          // set the selected card after scrolling
          props.doctorListDataFromParent?.map((listItem: DoctorDataModel) => {
            return selectedCards.forEach(
              (selectedCardItem: DoctorDataModel) => {
                if (selectedCardItem.guid === listItem.guid) {
                  listItem.isSelected = true;
                }
              }
            );
          });

          setDoctorListData(_.cloneDeep(props.doctorListDataFromParent));
        } else {
          setDoctorListData("");
        }
        setLoaderStatus(false);
        break;
    }
  };

  async function getSwapCallDoctorListDetails(params: doctorListParams) {
    setLoaderStatus(true);
    const respDoctorListResult: doctorListResultInterface =
      await doctorsListService.getSwapCallDoctorList(params);
    if (respDoctorListResult.isSuccess) {
      if (!_.isEmpty(respDoctorListResult.doctorListResult)) {
        setDoctorListData(respDoctorListResult.doctorListResult);
      } else {
        setDoctorListData("");
      }
    } else {
      doctorsListService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  async function getRequestCoverageDoctorListDetails(params: doctorListParams) {
    setLoaderStatus(true);
    const respDoctorListResult: doctorListResultInterface =
      await doctorsListService.getRequestCoverageDoctorList(params);
    if (respDoctorListResult.isSuccess) {
      if (!_.isEmpty(respDoctorListResult.doctorListResult)) {
        setDoctorListData(respDoctorListResult.doctorListResult);
      } else {
        setDoctorListData("");
      }
    } else {
      doctorsListService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  async function getOnCallLookUpDoctorListDetails(params: doctorListParams) {
    setLoaderStatus(true);
    const respOnCallDoctorListResult: any =
      await doctorsListService.getOnCallLookUpDoctorList(params,selectedNetwork?.value??'');
    const respNotOnCallDoctorListResult: any =
      await doctorsListService.getNotOnCallLookUpDoctorList(params,selectedNetwork?.value??'');

    if (
      respOnCallDoctorListResult.isSuccess ||
      respNotOnCallDoctorListResult.isSuccess
    ) {
      setDoctorAvailableList(respOnCallDoctorListResult?.doctorListResult);
      setTemplateAvailabilityList(
        respNotOnCallDoctorListResult?.doctorListResult
      );
      if (props?.activeTab !== "oncall") {
        setDoctorListData(respNotOnCallDoctorListResult?.doctorListResult);
      }
      if (props?.optionSelected === "individual_provider") {
        setDoctorListData(respNotOnCallDoctorListResult?.doctorListResult);
        filterSearchedCoverageDoctor(
          respNotOnCallDoctorListResult?.doctorListResult
        );
      }
    } else {
      doctorsListService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  async function getUnassignedUserList(params: doctorListParams) {
    setLoaderStatus(true);
    if (Object.values(params).length !== 0) {
      const respDoctorListResult: doctorListResultInterface =
        await doctorsListService.getUnassignedUserList(params);
      if (respDoctorListResult.isSuccess) {
        if (!_.isEmpty(respDoctorListResult.doctorListResult)) {
          setDoctorListData(respDoctorListResult.doctorListResult);
          applyRule(respDoctorListResult.doctorListResult);
        } else {
          setDoctorListData([]);
        }
      } else {
        doctorsListService.handleErrorResponse();
      }
    }
    setLoaderStatus(false);
  }

  async function getStatusBoardDoctorListDetails(params: doctorListParams) {
    setLoaderStatus(true);
    const respDoctorListResult: doctorListResultInterface =
      await doctorsListService.getStatusBoardDoctorList(params);
    if (respDoctorListResult.isSuccess) {
      if (!_.isEmpty(respDoctorListResult.doctorListResult)) {
        setDoctorListData(respDoctorListResult.doctorListResult);
        sBoardProviderService.setDoctorListDataFromComponent(
          respDoctorListResult.doctorListResult
        );
      } else {
        setDoctorListData("");
      }
    } else {
      doctorsListService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const clearSelection = () => {
    setDoctorListData(
      doctorListData.map((doctor: any) => {
        return {
          ...doctor,
          isSelected: false,
        };
      })
    );
    setSelectedCards([]);
  };

  useEffect(() => {
    if (
      props?.chatSelectedUser?.length === 0 &&
      props?.doctorListInputData?.componentName === "FileShare"
    ) {
      clearSelection();
    }
  }, [props?.chatSelectedUser]);

  useEffect(() => {
    setLoaderStatus(props?.loader)
  }, [props?.loader]);

  return (
    <div className="ion-padding">
      {!isCoveredDoctorPresent ? (
        <div>
          <div className="doctor-list-div">
            <IonRow>
              {isLoaderActive && (
                <div className="loader-container">
                  {/* <Loader></Loader> */}
                </div>
              )}

              {props?.doctorListInputData?.componentName === "OnCallLookUp" ? (
                <div className="available-by-div day-view-container">
                
                  {props?.optionSelected !== "individual_provider" &&
                    props?.activeTab === "oncall" &&
                    (doctorAvailableList?.length !== 0 ? (
                      <div className="day-view-accordion-wrapper">
                        <Accordion
                          multiple
                          activeIndex={activeIndex}
                          onTabChange={(e) => setActiveIndex(e.index)}
                        >
                          {doctorAvailableList?.map(
                            (data: any, index: number) => {
                              return (
                                <AccordionTab
                                  key={index}
                                  header={
                                    <React.Fragment>
                                      <div className="accordianTab-container">
                                        <div className="shift-details-div">
                                          <span
                                            className="shift-name-label"
                                            style={{
                                              textOverflow: "initial",
                                              width: "100%",
                                            }}
                                          
                                          >
                                            {data?.schedule_name}
                                          </span>
                                         
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  }
                                >
                                  <div className="accordion-content-container">
                                    <div>
                                      {doctorsListService
                                        ?.setDoctorListModel(data?.users)
                                        ?.map(
                                          (
                                            item: DoctorDataModel,
                                            index: number
                                          ) => {
                                            return (
                                              <IonCol
                                                size-lg={columnSize}
                                                size="12"
                                                key={item.guid}
                                              >
                                                <DoctorCard
                                                  key={index}
                                                  doctorData={item}
                                                  getSelectedCards={
                                                    setSelectedCardList
                                                  }
                                                  doctorListInputDetails={
                                                    props.doctorListInputData
                                                  }
                                                  rolePermissions={
                                                    props.permissions
                                                  }
                                                  hideFeatureButtons={
                                                    props.hideFeatureButtons
                                                  }
                                                  apiParameters={
                                                    props.apiParams
                                                  }
                                                  numberBadge={item.numberBadge}
                                                  isFromCaseHistoryDetails={
                                                    props?.isFromCaseHistoryDetails
                                                  }
                                                  patientID={props.patientID}
                                                  patientDataID={
                                                    props.patientID
                                                  }
                                                  isFromOnCallSearch={
                                                    props.isFromOnCallSearch
                                                  }
                                                ></DoctorCard>
                                              </IonCol>
                                            );
                                          }
                                        )}
                                    </div>
                                  </div>
                                </AccordionTab>
                              );
                            }
                          )}
                        </Accordion>
                      </div>
                    ) : (
                      <div style={{ margin: "30% 0 0 0" }}>
                        <NoResults></NoResults>
                      </div>
                    ))}

              
                  {props?.optionSelected !== "individual_provider" &&
                    props?.activeTab === "notoncall" && (
                      <div>
                        {templateAvailabilityList.length !== 0 ? (
                          <div
                            className="doctor-list-div"
                            style={{ padding: "1rem 1.5rem" }}
                          >
                            <IonRow>
                              {templateAvailabilityList &&
                              templateAvailabilityList.length > 0
                                ? templateAvailabilityList.map(
                                    (item: DoctorDataModel, index: number) => {
                                      return (
                                        <IonCol
                                          size-lg={columnSize}
                                          size="12"
                                          key={item.guid}
                                        >
                                          <DoctorCard
                                            key={index}
                                            doctorData={item}
                                            getSelectedCards={
                                              setSelectedCardList
                                            }
                                            doctorListInputDetails={
                                              props.doctorListInputData
                                            }
                                            rolePermissions={props.permissions}
                                            hideFeatureButtons={
                                              props.hideFeatureButtons
                                            }
                                            apiParameters={props.apiParams}
                                            numberBadge={item.numberBadge}
                                            isFromCaseHistoryDetails={
                                              props?.isFromCaseHistoryDetails
                                            }
                                            patientID={props.patientID}
                                            patientDataID={props.patientID}
                                            isFromOnCallSearch={
                                              props.isFromOnCallSearch
                                            }
                                          ></DoctorCard>
                                        </IonCol>
                                      );
                                    }
                                  )
                                : null}
                            </IonRow>
                          </div>
                        ) : (
                          <div style={{ margin: "30% 0 0 0" }}>
                            <NoResults></NoResults>
                          </div>
                        )}
                      </div>
                    )}

                  {/* individaul provider list */}
                  {props?.optionSelected === "individual_provider" && (
                    <div style={{ padding: "0rem 1.5rem" }}>
                      {templateAvailabilityList.length > 0 ? (
                        templateAvailabilityList?.map(
                          (item: DoctorDataModel, index: number) => {
                            return (
                              <IonCol
                                size-lg={columnSize}
                                size="12"
                                key={item.guid}
                              >
                                <DoctorCard
                                  key={index}
                                  doctorData={item}
                                  getSelectedCards={setSelectedCardList}
                                  doctorListInputDetails={
                                    props.doctorListInputData
                                  }
                                  rolePermissions={props.permissions}
                                  hideFeatureButtons={props.hideFeatureButtons}
                                  apiParameters={props.apiParams}
                                  numberBadge={item.numberBadge}
                                  isFromCaseHistoryDetails={
                                    props?.isFromCaseHistoryDetails
                                  }
                                  patientID={props.patientID}
                                  patientDataID={props.patientID}
                                  isFromOnCallSearch={props.isFromOnCallSearch}
                                ></DoctorCard>
                              </IonCol>
                            );
                          }
                        )
                      ) : (
                        <div style={{ margin: "30% 0 0 0" }}>
                          <NoResults></NoResults>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ width: "100%" }}>
                  <div className="doctor-list-div">
                    <IonRow>
                      {!isLoaderActive ? (
                        !_.isEmpty(doctorListData)?
                         (
                          doctorListData.map(
                            (item: DoctorDataModel, index: number) => {
                              return (
                                <IonCol
                                  size-lg={columnSize}
                                  size="12"
                                  key={item.guid}
                                >
                                  <DoctorCard
                                    key={index}
                                    doctorData={item}
                                    getSelectedCards={setSelectedCardList}
                                    doctorListInputDetails={
                                      props.doctorListInputData
                                    }
                                    rolePermissions={props.permissions}
                                    hideFeatureButtons={
                                      props.hideFeatureButtons
                                    }
                                    apiParameters={props.apiParams}
                                    numberBadge={item.numberBadge}
                                    isFromCaseHistoryDetails={
                                      props?.isFromCaseHistoryDetails
                                    }
                                    patientID={props.patientID}
                                    patientDataID={props.patientID}
                                    isFromOnCallSearch={
                                      props.isFromOnCallSearch
                                    }
                                    isFromSpecialitySearch={
                                      props.isFromSpecialitySearch
                                    }
                                  ></DoctorCard>
                                </IonCol>
                              );
                            }
                          )
                        ) : 
                         (
                            <IonCol size-lg="12" size="12">
                              <span>
                                <NoResults></NoResults>
                              </span>
                            </IonCol>
                          )
                        )
                     : (
                        <div className="loader-container">
                          <Loader></Loader>
                        </div>
                      )}
                    </IonRow>
                  </div>
                </div>
              )}
            </IonRow>
          </div>
        </div>
      ) : (
        <div>
          {!isLoaderActive ? (
            <div>
              <div>
                {searchedDoctorData && (
                  <div className="doctor-list-div">
                    <IonRow>
                      {searchedDoctorData ? (
                        <IonCol size-lg={columnSize} size="12">
                          <DoctorCard
                            doctorData={searchedDoctorData}
                            getSelectedCards={setSelectedCardList}
                            doctorListInputDetails={props.doctorListInputData}
                            rolePermissions={props.permissions}
                            hideFeatureButtons={props.hideFeatureButtons}
                            apiParameters={props.apiParams}
                            numberBadge={searchedDoctorData.numberBadge}
                            isFromCaseHistoryDetails={
                              props?.isFromCaseHistoryDetails
                            }
                            patientID={props.patientID}
                            patientDataID={props.patientID}
                            isFromOnCallSearch={props.isFromOnCallSearch}
                          ></DoctorCard>
                        </IonCol>
                      ) : (
                        <div className="no-results-label">{t("noResults")}</div>
                      )}
                    </IonRow>
                  </div>
                )}
              </div>
              <div>
                {componentName == CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                  <div className="covered-by-div">Covered By :</div>
                )}
              </div>

              <div>
                {filteredDoctorData && (
                  <div className="doctor-list-div">
                    <IonRow>
                      {filteredDoctorData && filteredDoctorData.length > 0
                        ? filteredDoctorData.map(
                            (item: DoctorDataModel, index: number) => {
                              return (
                                <IonCol
                                  size-lg={columnSize}
                                  size="12"
                                  key={item.guid}
                                >
                                  <DoctorCard
                                    key={index}
                                    doctorData={item}
                                    getSelectedCards={() => {}}
                                    doctorListInputDetails={
                                      props.doctorListInputData
                                    }
                                    rolePermissions={props.permissions}
                                    hideFeatureButtons={
                                      props.hideFeatureButtons
                                    }
                                    apiParameters={props.apiParams}
                                    numberBadge={item.numberBadge}
                                    isFromCaseHistoryDetails={
                                      props?.isFromCaseHistoryDetails
                                    }
                                    patientID={props.patientID}
                                    patientDataID={props.patientID}
                                    isFromOnCallSearch={
                                      props.isFromOnCallSearch
                                    }
                                  ></DoctorCard>
                                </IonCol>
                              );
                            }
                          )
                        : null}
                    </IonRow>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="doctor-list-div">
              {isLoaderActive && (
                <div className="loader-container-div">
                  <Loader></Loader>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DoctorList;
